import { useEffect } from 'react';
import { termsOfUse } from './terms_of_use';
import { Page, Container, DocumentBody } from './styles';
import { motion } from 'framer-motion';

const TermsOfUsePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <Container>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={{ width: '100%' }}
        >
          <DocumentBody dangerouslySetInnerHTML={{ __html: termsOfUse }} />
        </motion.div>
      </Container>
    </Page>
  );
};

export default TermsOfUsePage;
